import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import './kyc.css';

import { v4 as uuidv4 } from 'uuid';
import { Link } from "react-router-dom";
import { store } from "../../redux/store";
import { setPersonalInfo, setRegisterRetailerResponse, setROId, setROResponse } from "../../redux/retailer-kyc-details/retailer-kyc-details.action";
import RegisterRetialerHeader from "../HeaderComponent/RegisterRetialerHeader";
import tokenErrorHandler from "../tokenErrorHandler";
import { setBranchAddress, setIfscCode, setSelectedBankName } from "../../redux/misc-data/misc-data.action";
const httpClient = axios.create();
class SetPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMsg: '',
            progress: '',
            otp: '',
            enteredPassword: '',
            passwordErrMsg: '',
            confirmedPassword: '',
            confirmPassWordErrMsg: '',
            finalizeErr: ''

        }
    }

    componentDidMount() {
        // store.dispatch(setIfscCode(''));
        // store.dispatch(setBranchAddress(''));
        // store.dispatch(setSelectedBankName(''));
    }
    componentWillUnmount() { }

    finalizeValidation = () => {

        this.setState({
            passwordErrMsg: '',
            confirmPassWordErrMsg: ''

        })

        var passwordValidation = false;
        var confirmValidation = false;
        if (this.state.enteredPassword != '') {
            passwordValidation = true;
        } else {
            this.setState({
                passwordErrMasg: 'Please enter password'
            })
        }
        if (this.state.confirmedPassword != '' &&
            (this.state.enteredPassword == this.state.confirmedPassword)) {
            confirmValidation = true;
        } else {
            this.setState({
                confirmPassWordErrMsg: 'Password Mismatch'
            })
        }

        if (passwordValidation == true && confirmValidation == true) {
            return true;
        } else {
            return false;
        }

    }
    finalize = (event) => {
        event.preventDefault();
        this.setState({
            errorMsg: '',
            progress: 'loading'
        })
        if (this.finalizeValidation() == true) {
            this.setState({
                finalizeErr: ''
            })
            var finalizeUrl = '/api/v1/retailer/onboard/session/finalize';
            var header = {
                msgType: "CREATE_ORDER",
                service: "KYC",
                src: "register-retailer",
                dst: "register-retailer",
                channel: "API",
                requesterId: 'W9853028034FPAY',
                requestId: uuidv4(),
                traceId: uuidv4(),
            }
            var request = {
                header: header,
                password: this.state.enteredPassword,
                sessionId: this.props.registerRetailerResponse.sessionId,
            }
            // const headers = {
            //     'Authorization': 'Bearer ' + this.props.token,
            //     'client-id': this.props.agentInfo.id,
            //     'role': this.props.clientRole
            // }
            httpClient.post(finalizeUrl, request,
                // { headers }
            ).then((response) => {
                console.log('finalize response' + JSON.stringify(response.data));
                if (response.data.response.success == true) {
                    store.dispatch(setROResponse(response.data));
                    store.dispatch(setROId(response.data.retailerId));

                    var gotoKycDetailsBtn = document.getElementById('gotoKycDetailsBtn');
                    gotoKycDetailsBtn.click();
                    // this.assignAgentToRoId(response.data.retailerId);
                } else {

                    this.setState({
                        progress: 'completed',
                        finalizeErr: response.data.response.displayMsg
                    })
                    //temp

                    // store.dispatch(setROResponse(response.data));
                    // store.dispatch(setROId(response.data.retailerId));
                    // this.assignAgentToRoId(response.data.retailerId);
                }
            }).catch(error => {

                this.setState({
                    progress: 'completed',
                    finalizeErr: 'Something went wrong'
                })
                if (error.message.includes("401")) {
                    tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                } else {

                }
        

            });
        }
    }

    goToUploadDoc = () => {
        var goToUploadDocBtn = document.getElementById('goToUploadDocBtn');
        goToUploadDocBtn.click();

    }

    enterPassword = (event) => {
        event.preventDefault();
        this.setState({
            enteredPassword: event.target.value,
            passwordErrMsg: ''
        })
    }
    confirmPassword = (event) => {
        event.preventDefault();
        this.setState({
            confirmedPassword: event.target.value,
            confirmPassWordErrMsg: ''
        })
    }

    backToBank = () => {
        var backToBankBtn = document.getElementById('backToBankBtn');
        backToBankBtn.click();
    }





    render() {


        return (
            <div>
                <RegisterRetialerHeader />
                <div class="mid-contant">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="main-heading">
                                    <h2>Verify Mobile number</h2>
                                </div>
                                <Link to='/kyc-details'>
                                    <button id='gotoKycDetailsBtn' hidden={true}></button>
                                </Link>
                            </div>

                            <div class="col-12">
                                <div class="registerbox">
                                    <div class="row mb-3">
                                        <div class="col-12 col-lg-7">
                                            {/* <form action="document.html"> */}
                                            <div class="row">

                                                <div class="col-12">
                                                    <div class="otptxt">Set Password:</div>
                                                </div>

                                                <div class="col-12 col-md-8">
                                                    <div class="form-floating">
                                                        <input type="password" class="form-control" id="otp" placeholder="Enter PASSWORD"
                                                            onChange={this.enterPassword}
                                                            value={this.state.enteredPassword}
                                                        />
                                                        <label for="otp">Enter PASSWORD</label>
                                                    </div>
                                                    {this.state.passwordErrMsg != '' &&
                                                        <div class='valid-error'>
                                                            {this.state.passwordErrMsg}
                                                        </div>}
                                                </div>


                                                <div class="col-12 col-md-8">
                                                    <div class="form-floating">
                                                        <input type="password" class="form-control" id="otp" placeholder="Confirm PASSWORD"
                                                            onChange={this.confirmPassword}
                                                            value={this.state.confirmedPassword}
                                                        />
                                                        <label for="otp">Confirm PASSWORD</label>
                                                    </div>
                                                    {this.state.confirmPassWordErrMsg != '' &&
                                                        <div class='valid-error'>
                                                            {this.state.confirmPassWordErrMsg}
                                                        </div>}
                                                </div>

                                                <div class="col-6 col-md-5">
                                                    <button type="button" class="btn btn-primary" id=""
                                                        onClick={this.finalize}
                                                        disabled={this.state.progress == 'laoding' && true}
                                                    >Proceed</button>
                                                    {this.state.finalizeErr != '' &&
                                                        <div class='valid-error'>
                                                            {this.state.finalizeErr}</div>}

                                                </div>

                                                <div class="col-12 mt-4 d-none">
                                                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                    <div class="timmer">45</div>
                                                </div>
                                            </div>
                                            {/* </form> */}
                                        </div>

                                        <div class="col-12 col-lg-5 d-none d-lg-block border-start">
                                            <div class="topbtn">
                                                <a onClick={this.backToBank}>Back</a>
                                            </div>
                                            <Link to='/retailer-bank'>
                                                <button id='backToBankBtn' hidden={true}></button>
                                            </Link>
                                            <div class="rightbanner"><img src="images/otp-img.png" alt="Oxigen" class="img-fluid" /></div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { phone, token, clientRole, agentInfo, clientRequesterId, callBackUrl },
        retailerKycReduce: { registerRetailerResponse }
    }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, phone, token, clientRole, agentInfo,
    clientRequesterId, callBackUrl, registerRetailerResponse
});

export default connect(mapStateToProps, null)(SetPassword);
